export const markdownMessages = {
  "markdown.codeBlock.copy.label": "Copy",
  "markdown.codeBlock.copy.copied": "Copied!",
  "markdown.codeBlock.copy.failed": "Failed",
  "markdown.codeBlock.wrap.enable": "Enable word wrap",
  "markdown.codeBlock.wrap.disable": "Disable word wrap",

  "markdown.copy": "Copy",
} as const
